import 'vue'
import 'vuex'
import axios from 'axios'
import 'fuse.js'
import 'vue-awesome-swiper'
import $ from 'jquery'
window.$ = window.jQuery = $

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'


String.prototype.toCamelCase = function() {
  return this
    .replace(/\s(.)/g, function($1) { return $1.toUpperCase(); })
    .replace(/\s/g, '')
    .replace(/^(.)/, function($1) { return $1.toLowerCase(); });
}

String.prototype.toTitle = function(str) {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

Date.prototype.addDays = function(days) {
  var dat = new Date(this.valueOf())
  dat.setDate(dat.getDate() + days)

  return dat
}

Date.prototype.getOnlyDate = function() {
  return new Date(this.toISOString().substring(0, 10))
}

Date.getMax = function(dates) {
  return new Date(Math.max.apply(Math, dates))
}

String.prototype.format = function(kwargs) {
  let str = '' + this

  Object.keys(kwargs).forEach(key => {
    str = str.replace(new RegExp(`\\\$\\{${key}\\}`, 'img'), kwargs[key])
  })

  return str
}

Array.prototype.has = function(element) {
  return this.indexOf(element) !== -1
}



// WEBPACK FOOTER //
// ./src/js/vendor.js